export enum SocialMediaEnum {
    FACEBOOK = 'FACEBOOK',
    TWITTER = 'TWITTER',
    LINKEDIN = 'LINKEDIN',
    INSTAGRAM = 'INSTAGRAM',
    YOUTUBE = 'YOUTUBE',
    SPOTIFY = 'SPOTIFY',
    TIKTOK = 'TIKTOK',
    DRIBBBLE = 'DRIBBBLE',
    BEHANCE = 'BEHANCE',
    PINTEREST = 'PINTEREST',
    WHATSAPP = 'WHATSAPP',
    TWITCH = 'TWITCH',
    OTHER = 'OTHER'
};
  